import CustomPopover, { usePopover } from '@/components/overlays/custom-popover';
import IconButton from '@mui/material/IconButton';
import Iconify from '@/components/media/iconify';
import MenuItem from '@mui/material/MenuItem';
import { m } from 'framer-motion';
import { useCallback } from 'react';
import { useLocales } from '@/hooks';
import { varHover } from '@/components/utils/animate';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@mui/material';

// ----------------------------------------------------------------------

export default function LanguagePopover() {
  const { t } = useTranslation();
  const locales = useLocales();

  const popover = usePopover();

  const handleChangeLang = useCallback(
    (newLang: string) => {
      locales.onChangeLang(newLang);
      popover.onClose();
    },
    [locales, popover]
  );
  return (
    <>
      <Tooltip title={t('Language')}>
        <IconButton
          component={m.button}
          whileTap="tap"
          whileHover="hover"
          variants={varHover(1.05)}
          onClick={popover.onOpen}
          sx={{
            width: { xs: 32, sm: 36, md: 40 },
            height: { xs: 32, sm: 36, md: 40 },
            p: { xs: 0.5, sm: 0.75, md: 1 },
            ...(popover.open && {
              bgcolor: 'action.selected',
            }),
          }}
        >
          <Iconify
            icon={locales.currentLang.icon}
            sx={{
              borderRadius: 0.65,
              width: { xs: 20, sm: 24, md: 28 },
            }}
          />
        </IconButton>
      </Tooltip>

      <CustomPopover open={popover.open} onClose={popover.onClose} sx={{ width: 160 }}>
        {locales.allLangs.map((option) => (
          <MenuItem
            key={option.value}
            selected={option.value === locales.currentLang.value}
            onClick={() => handleChangeLang(option.value)}
          >
            <Iconify
              icon={option.icon}
              sx={{
                borderRadius: 0.65,
                width: { xs: 20, sm: 24, md: 28 },
                mr: 1,
              }}
            />

            {t(option.label)}
          </MenuItem>
        ))}
      </CustomPopover>
    </>
  );
}
